import themeVariables from "@/config/theme/themeVariable";
import { Button, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useRouter } from "next/navigation";

interface SafeHospitalModalProps {
  forceOpened?: boolean;
  onClose?: () => void;
}

export const SafeHospitalModal = ({ forceOpened = false, onClose }: SafeHospitalModalProps) => {
  const [opened, { open, close }] = useDisclosure(forceOpened);
  const searchParams = useSearchParams();
  const router = useRouter();
  
  useEffect(() => {
    if (searchParams?.get('modal') === 'safehospital' || forceOpened) {
      open();
    }
  }, [searchParams, open, forceOpened, close]);

  const items = [
    { id: 'hospital', image: 'https://ucarecdn.com/26889304-a1c8-42d0-b121-b51a318c6f1a/Logo.png', alt: '병원 정보', path: '/safe-hospital/hospital?from_modal=safehospital' }
  ];

  const handleItemClick = (id: string) => {
    const item = items.find(item => item.id === id);
    if (item && item.path) {
      router.push(item.path);
      close();
      if (onClose) onClose();
    }
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          close();
          if (onClose) onClose();
        }}
        withCloseButton={false}
        centered
        radius={'lg'}
        padding={24}
        size='lg'
        closeOnClickOutside={true}
        classNames={{ 
        content: 'scrollbar-hide', 
        }}
      >
        <div className="flex flex-col gap-3 mb-10">
          <div className="text-lg text-gray-700 dark:text-gray-100 font-semibold" data-autofocus>
            안전한 병원 선택하기
          </div>
          <div className="text-[15px] text-gray-700 dark:text-gray-100 font-normal">
            Kuxy는 여러분의 더 안전하고 만족스러운 성형 여정을 끝까지 책임지겠습니다
          </div>
        </div>
        
        <div className="flex justify-center mb-4 max-w-[560px] mx-auto">
          {items.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col items-center justify-center gap-3 border border-gray-200 dark:border-gray-700 p-2 text-center h-28 text-gray-700 text-[15px] font-normal hover:border-blue-700 hover:text-blue-700 dark:hover:text-blue-400 transition-colors cursor-pointer rounded-2xl bg-white dark:bg-gray-800`}
              onClick={() => item.id && handleItemClick(item.id)}
            >
              <img src={item.image as string} alt={item.alt || 'Icon'} className="w-full h-full object-cover rounded-2xl" />
            </div>
          ))}
        </div>
        
        <div className="flex gap-1 justify-end mt-5">
          <Button 
            classNames={themeVariables.button.gray} 
            onClick={() => {
              close();
              if (onClose) onClose();
            }}
          >
            닫기
          </Button>
        </div>
      </Modal>
    </>
  )
}; 